import UserStore from './UserStore'

const removeUser = () => {
  const userStore = new UserStore()
  userStore.removeUser()
}

export default removeUser